import axios from "axios";
import config from "../../../settings/config";
import { handleError } from "../../../network/servicErrorHandling";

axios.defaults.headers.common["Authorization"] = localStorage.getItem(
  `${window.location.hostname}_token`
);

async function shopCartItems(shop_uid) {
  return Promise.resolve().then((v) =>
    axios
      .get(`${config.baseUrl}v1/shops/${shop_uid}/cart`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function apiCartChangeProductQuantity(shop_uid, product_id, quantity) {
  return Promise.resolve().then((v) =>
    axios
      .get(
        `${config.baseUrl}v1/shops/${shop_uid}/cart/change/${product_id}/${quantity}`
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

export { shopCartItems, apiCartChangeProductQuantity };
